import React, { FC } from 'react'
import { FormattedMessage } from 'react-intl'
import sortBy from 'lodash/sortBy'
import isNaN from 'lodash/isNaN'
import isNil from 'lodash/isNil'

import { CustomPriceProps } from '../ProductSummary'

import { getCurrencyPrice } from '@/checkout-instore-legacy/utils/ProductUtils'
import IntlMessage from './IntlMessage'

const PLUS_LABEL = '+'
type Props = {
  prices: CustomPriceProps[]
  intl: any
}
const PriceDetail: FC<Props> = ({ prices, intl }) => {
  const validPrices = prices.filter(
    (price) => !isNaN(price.price) && !isNil(price.price)
  )
  const renderDetails = (price: number, quantity: number) => {
    const formattedPrice = getCurrencyPrice(price, intl)
    const message = price ? IntlMessage.promotionalPrice : IntlMessage.freePrice
    return (
      <FormattedMessage
        {...message}
        values={{
          quantity,
          price: formattedPrice,
        }}
      />
    )
  }
  const sortPrices = sortBy(validPrices, 'price').reverse()
  if (sortPrices.length === 1) {
    return null
  }
  return (
    <div
      className="t-small-ns t-mini-s c-muted-2 flex flex-column-s flex-row-ns mt2-ns"
      data-cy="product-summary__price-detail"
    >
      {sortPrices.map(({ price, quantity }, index) => {
        const plus = index > 0 && (
          <span className="ph1 dn-s di-ns ml2-ns mr2-ns">{PLUS_LABEL}</span>
        )
        return (
          <span key={price * quantity + index} className="mb3-s mb0-ns">
            {plus}
            <span>{renderDetails(price, quantity)}</span>
          </span>
        )
      })}
    </div>
  )
}

export default PriceDetail
